// src/pages/school_exams/template_builder/Canvas.js
import React from "react";
import DraggableItem from "./DraggableItem";

const PAGE_WIDTH = 794;
const PAGE_HEIGHT = 1123;

const snap = (value, step = 5) => Math.round(value / step) * step;

const Canvas = ({
  background,
  elements,
  setElements,
  selectedIds,
  setSelectedIds,
  zoom,
  showGrid,
}) => {
  const handleUpdate = (id, changes) => {
    setElements((prev) =>
      prev.map((el) =>
        el.id === id
          ? {
              ...el,
              ...changes,
              ...(changes.x !== undefined && { x: snap(changes.x) }),
              ...(changes.y !== undefined && { y: snap(changes.y) }),
            }
          : el
      )
    );
  };

  const handleSelect = (id, shiftKey) => {
    if (!id) return setSelectedIds([]);
    if (shiftKey) {
      setSelectedIds((prev) =>
        prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
      );
    } else {
      setSelectedIds([id]);
    }
  };

  const handleEmptyClick = () => setSelectedIds([]);

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        background: "#e5e7eb",
        overflow: "auto",
        padding: 16,
      }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) handleEmptyClick();
      }}
    >
      <div
        style={{
          position: "relative",
          width: PAGE_WIDTH * zoom,
          height: PAGE_HEIGHT * zoom,
          boxShadow: "0 0 10px rgba(0,0,0,0.35)",
          backgroundColor: "#ffffff",
          backgroundImage: background ? `url(${background})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
        onMouseDown={(e) => {
          if (e.target === e.currentTarget) handleEmptyClick();
        }}
      >
        {/* Grid */}
        {showGrid && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage:
                "linear-gradient(to right, rgba(0,0,0,0.06) 1px, transparent 1px)," +
                "linear-gradient(to bottom, rgba(0,0,0,0.06) 1px, transparent 1px)",
              backgroundSize: `${20 * zoom}px ${20 * zoom}px`,
              pointerEvents: "none",
            }}
          />
        )}

        {/* Center guides */}
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: 0,
            bottom: 0,
            width: 1,
            background: "rgba(37,99,235,0.25)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: 0,
            right: 0,
            height: 1,
            background: "rgba(37,99,235,0.25)",
            pointerEvents: "none",
          }}
        />

        {elements.map((item) => (
          <DraggableItem
            key={item.id}
            item={item}
            selected={selectedIds.includes(item.id)}
            onSelect={handleSelect}
            onUpdate={handleUpdate}
            scale={zoom}
          />
        ))}
      </div>
    </div>
  );
};

export default Canvas;
